import { Injectable } from "@angular/core";
import { AngularFirestore, QueryDocumentSnapshot, DocumentData, DocumentReference } from '@angular/fire/firestore';
import { Booking } from '../models/booking.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MailService } from "./mail.service";
import { Practitioner } from "../models/practitioner.model";

@Injectable()
export class BookingService {

  constructor(private firestore: AngularFirestore, private mailService: MailService){}

  getBookings(practitionerId: string): Observable<Booking[]> {
    return this.firestore.collection('practitioners').doc(practitionerId).collection('bookings').get()
      .pipe(map(query => {
        var bookings: Booking[] = [];
        query.forEach((document: QueryDocumentSnapshot<DocumentData>) => {
          bookings.push(Booking.mapFromFirestore(document.data(), document.id));
        });
        return bookings;
      }));
  }

  createBooking(practitioner: Practitioner, booking: Booking): Promise<Booking> {
    return new Promise<Booking>((resolve, reject) => {
      this.firestore.collection('practitioners').doc(booking.practitionerId).collection('bookings').add(booking.mapToFirestore())
        .then((docRef: DocumentReference) => {
          booking.id = docRef.id;
          this.mailService.sendPractitionerBookingReceivedEmail(practitioner, booking);
          this.mailService.sendClientBookingRequestedEmail(practitioner, booking);
          resolve(booking);
        }, _ => {
          reject('There was an error requesting your booking.');
        });
    });
  }

  updateBooking(booking: Booking): Promise<Booking> {
    return new Promise<Booking>((resolve, reject) => {
      this.firestore.collection('practitioners').doc(booking.practitionerId)
        .collection('bookings').doc(booking.id).set(booking.mapToFirestore())
        .then(_ => {
          resolve(booking);
        })
        .catch(_ => {
          reject('There was an error completing this booking.')
        });
    });
  }
}
